import Footer from 'components/Navigation/Footer';
import AuthHeader from 'components/Navigation/AuthHeader';
import { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { useTheme } from 'styled-components';
import { FooterWrapper, HeaderWrapper } from '../Default/styles';

interface LayoutProps {
  children: ReactNode;
}

export const AuthLayout = ({ children }: LayoutProps) => {
  const { colors } = useTheme();

  return (
    <>
      <HeaderWrapper>
        <AuthHeader />
      </HeaderWrapper>
      <Box
        as="main"
        pos="relative"
        zIndex={0}
        bg={colors.accent.beige}
        borderBottom={`1px solid ${colors.geyser}`}
      >
        {children}
      </Box>
      <FooterWrapper>
        <Footer />
      </FooterWrapper>
    </>
  );
};
